import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  style: {"display":"flex"},
  class: "gd addprojectlog-wrap"
}
const _hoisted_2 = { style: {"width":"50%"} }
const _hoisted_3 = { style: {"display":"flex","align-items":"flex-end"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "基本信息", -1)
const _hoisted_5 = { style: {"font-size":"22px"} }
const _hoisted_6 = { class: "cell-item" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("项目编号 ")
const _hoisted_8 = { class: "cell-item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("项目类型 ")
const _hoisted_10 = { class: "cell-item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("开始时间 ")
const _hoisted_12 = { class: "cell-item" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("结束时间 ")
const _hoisted_14 = { class: "cell-item" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("创建人 ")
const _hoisted_16 = { class: "cell-item" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("可见人 ")
const _hoisted_18 = { class: "cell-item" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("状态 ")
const _hoisted_20 = { class: "cell-item" }
const _hoisted_21 = { class: "cell-item" }
const _hoisted_22 = { style: {"float":"left","margin-left":"10px"} }
const _hoisted_23 = { class: "cell-item" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("备注 ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "周计划订单明细表", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    style: {"color":"blue","margin":"10px 0px","line-height":"40px"},
    href: "/template/week.xlsx",
    target: "_blank"
  }, "模版下载"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","margin-left":"20px"} }, "上传文件请先解密")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "周计划订单明细表", -1)
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "添加日志", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_48 = { style: {"display":"flex","align-items":"center","gap":"8px","flex-wrap":"wrap"} }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_50 = { class: "paste_tip" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_52 = { class: "flexCenter" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("提交日志")
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "复盘总结", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_59 = { class: "flexCenter" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("提交复盘总结")
const _hoisted_61 = { style: {"width":"50%"} }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title flexCenter" }, "日志展示", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)
const _hoisted_64 = { key: 0 }
const _hoisted_65 = ["href", "download"]

import { ref,onMounted,onBeforeUnmount,computed } from 'vue';
	import { apiName } from '@/api/api';
	import { requestSaveProjectFp,requestAddProjectlog,requestProjectlogList,xmUser,requestGetProjectStep,requestSetProjectStepDate,requestSetProjectStepOperator,requestProjectWeek,requestGetWeekList,requestUpdatePlandate } from '@/api/xmApi';
	import { ElMessage } from 'element-plus';
	import type { UploadUserFile } from 'element-plus'
	
export default /*#__PURE__*/_defineComponent({
  name: 'AddProjectlog',
  props: {
		projectnr:{
			type: Object,
			default: () => {}
		},
		// 由"项目所有附件"跳转进来时，需要定位到的项目日志 id
		focusLogId:{
			type: [String, Number],
			default: ''
		}
	},
  setup(__props) {

const props = __props

	const fileList = ref<UploadUserFile[]>([])
	const fileList2 = ref<UploadUserFile[]>([])
	const logForm = ref({
		updateremark:'',
		updatestatus:1
	})
	const logList = ref<any[]>([])
	
	const api = ref<string>(apiName)
	const userLists = ref<any[]>([])
	const projectNr = ref<any>({})
	const projectStep = ref<any[]>([])
	const projectWeek = ref<any[]>([])
	const getStatus2 = computed(()=>{
		return function(status:number){
			let a = {
				1:"进行中",
				2:"关闭",
				3:"待审核",
				4:"完成"
			}
			return a[status]
		}
	})
	const getStatus = computed(()=>{
		return function(status:number){
			let a = {
				1:"进行中",
				2:"关闭",
				3:"完成",
				4:"恢复"
			}
			return a[status]
		}
	})
	onMounted(()=>{
		// 日志附件支持 Ctrl + V 粘贴上传
		document.addEventListener('paste', onPaste)
		getUserList()
		projectNr.value = props.projectnr
		console.log(projectNr.value.type1);
		console.log(projectNr.value.weekpath);
		getLogList();
		GetProjectStep();
		GetWeek();//requestGetWeekList
	})

	onBeforeUnmount(()=>{
		document.removeEventListener('paste', onPaste)
	})

	// ===== 日志附件 Ctrl + V 粘贴上传 =====
	// 本组件有两处上传（周计划订单明细表 fileList2 / 日志附件 fileList），
	// 粘贴的附件固定落到【日志附件】（见页面提示），与提交日志的取值结构保持一致
	const pasteUploading = ref<boolean>(false)
	const uploadPasteFile = (file: File) => {
		pasteUploading.value = true
		const fd = new FormData()
		fd.append('file', file, file.name || ('paste_' + Date.now()))
		fetch(`${api.value}/frame/uploadfile1`, { method:'POST', credentials:'same-origin', body: fd })
			.then((r:any)=>r.json())
			.then((res:any)=>{
				if(res && res.errno === 0 && res.data && res.data[0]){
					const url = res.data[0].url || ''
					const rawName = res.data[0].name || ''
					const name = rawName ? decodeURIComponent(rawName) : (file.name || '附件')
					// 用 concat 而非展开语法：项目 tslib 版本较旧，缺少 __spreadArray 帮助器
				fileList.value = fileList.value.concat([{ name, url, response: { data: [{ url, name: rawName }] } }] as any)
					ElMessage({ message: '附件已上传', type: 'success', duration: 800 })
				}else{
					ElMessage({ message: (res && res.msg) || '附件上传失败', type: 'error', duration: 800 })
				}
			})
			.catch(()=>{
				ElMessage({ message: '附件上传失败', type: 'error', duration: 800 })
			})
			.finally(()=>{
				pasteUploading.value = false
			})
	}
	const onPaste = (e: ClipboardEvent) => {
		const items = e.clipboardData && e.clipboardData.items
		if(!items) return
		const files: File[] = []
		for(let i=0;i<items.length;i++){
			const it:any = items[i]
			if(it && it.kind === 'file' && it.getAsFile){
				const f = it.getAsFile()
				if(f) files.push(f)
			}
		}
		if(files.length === 0) return//纯文本粘贴不拦截，不影响输入框正常粘贴
		e.preventDefault()
		files.forEach((f:File)=>uploadPasteFile(f))
	}
	
	const changedatetime  = (row,dd,step) => {
		console.log(row.id,dd,step);
		row["plenddate"+step]=dd
		requestUpdatePlandate({weekid:row.id,date:dd,step:step}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "修改成功",
					type: 'success',
					duration: 500
				});
			}
		})
	}
	const GetWeek = () => {
		requestGetWeekList({projectid:projectNr.value.id}).then((res:any)=>{
			if(res.status === 1){
				projectWeek.value = res.datalist
				
			}
		})
	}
	const GetProjectStep = () => {
		requestGetProjectStep({uuid:projectNr.value.uuid}).then((res:any)=>{
			if(res.status === 1){
				projectStep.value = res.datalist
				for(var i=0;i<projectStep.value.length;i++){
					projectStep.value[i].operator=projectStep.value[i].operatoruserid+","+projectStep.value[i].operatorname
				}
			}
		})
	}
	const handleSuccess = () => {
		let fjArr:any[] = []
		fileList2.value.forEach((val:any)=>{
			fjArr.push(val.response.data[0].url)
		})
		requestProjectWeek({projectid:projectNr.value.id,projectuuid:projectNr.value.uuid,weekpath:fjArr.join(",")}).then((res:any)=>{
			if(res.status === 1){
				projectNr.value.weekpath=fjArr.join(",")
					ElMessage({
						message: "修改成功",
						type: 'success',
						duration: 500
					});
					setTimeout(()=>{
						GetWeek()
					},500)
			}
		})
	}
	// 跳转到指定日志（由"项目所有附件"点击描述进入）
	const scrollToFocusLog = () => {
		if (String(props.focusLogId) === '') return
		setTimeout(() => {
			const el = document.getElementById('projectlog-' + props.focusLogId)
			if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
		}, 500)
	}
	const getLogList = () => {
		requestProjectlogList({projectuuid:projectNr.value.uuid}).then((res:any)=>{
			if(res.status === 1){
				logList.value = res.datalist
				scrollToFocusLog()
			}
		})
	}
	const submitfp = () => {
		requestSaveProjectFp({
			id:projectNr.value.id,
			fp:projectNr.value.fp
		}).then((res:any)=>{
			ElMessage({
				message: res.msg,
				type: 'success',
				duration: 500
			});
		})
	}

	const submit = () => {
		let fjArr:any[] = []
		fileList.value.forEach((val:any)=>{
			fjArr.push(val.response.data[0].url)
		})
		if(logForm.value.updateremark === ""){
			ElMessage.error("请输入项目日志");
			return
		}
		requestAddProjectlog({
			projectuuid:projectNr.value.uuid,
			updateremark:logForm.value.updateremark,
			updatestatus:1,
			filelist:fjArr.join(",")
		}).then((res:any)=>{
			ElMessage({
				message: res.msg,
				type: 'success',
				duration: 500
			});
			setTimeout(()=>{
				logForm.value.updateremark = ""
				getLogList();
			},500)
		})
	}

	const getUserList = () =>{
		xmUser().then((res:any)=>{
			if(res.status === 1){
				userLists.value = res.datalist
			}
		})
	}
	const type1tostring = (val: number) =>{
		if(val==1){
			return  "项目售前"
		}
		if(val==2){
			return  "项目售中"
		}
		if(val==3){
			return  "项目售后"
		}
		if(val==4){
			return  "公司内部项目"
		}
		if(val==5){
			return  "周计划投产"
		}
		
		return "";
	}
	const changeplanendtime = (val0: string,val1: string,val2: string) =>{
		requestSetProjectStepDate({uuid:projectNr.value.uuid,key:val0,value:projectStep.value[val2-1][val0],
		stepindex:val2,key1:val1}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "修改成功",
					type: 'success',
					duration: 500
				});
				setTimeout(()=>{
					getLogList();
				},500)
			}
		})
	}
	const changezxr = (val: string) =>{
		requestSetProjectStepOperator({
			uuid:projectNr.value.uuid,
			operatoruserid:projectStep.value[val-1]["operator"].split(',')[0],
			operatorname:projectStep.value[val-1]["operator"].split(',')[1],
			stepindex:val
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "修改成功",
					type: 'success',
					duration: 500
				});
				setTimeout(()=>{
					getLogList();
				},500)
			}
		})
	}


return (_ctx: any,_cache: any) => {
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_Help = _resolveComponent("Help")!
  const _component_AlarmClock = _resolveComponent("AlarmClock")!
  const _component_Timer = _resolveComponent("Timer")!
  const _component_user = _resolveComponent("user")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_descriptions, {
        column: 2,
        border: "",
        title: ""
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, "（" + _toDisplayString(__props.projectnr.projectname) + "）", 1)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Document)
                  ]),
                  _: 1
                }),
                _hoisted_7
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                content: __props.projectnr.code,
                placement: "top",
                disabled: !__props.projectnr.code
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.projectnr.code), 1)
                ]),
                _: 1
              }, 8, ["content", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Help)
                  ]),
                  _: 1
                }),
                _hoisted_9
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                content: type1tostring(__props.projectnr.type1),
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(type1tostring(__props.projectnr.type1)), 1)
                ]),
                _: 1
              }, 8, ["content"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AlarmClock)
                  ]),
                  _: 1
                }),
                _hoisted_11
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                content: __props.projectnr.startdate,
                placement: "top",
                disabled: !__props.projectnr.startdate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.projectnr.startdate), 1)
                ]),
                _: 1
              }, 8, ["content", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Timer)
                  ]),
                  _: 1
                }),
                _hoisted_13
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                content: __props.projectnr.enddate,
                placement: "top",
                disabled: !__props.projectnr.enddate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.projectnr.enddate), 1)
                ]),
                _: 1
              }, 8, ["content", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_user)
                  ]),
                  _: 1
                }),
                _hoisted_15
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                content: __props.projectnr.createname,
                placement: "top",
                disabled: !__props.projectnr.createname
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tag, { size: "small" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.projectnr.createname), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["content", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_user)
                  ]),
                  _: 1
                }),
                _hoisted_17
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                content: __props.projectnr.username,
                placement: "top",
                disabled: !__props.projectnr.username
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.projectnr.username), 1)
                ]),
                _: 1
              }, 8, ["content", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Help)
                  ]),
                  _: 1
                }),
                _hoisted_19
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                content: _unref(getStatus)(__props.projectnr.status),
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getStatus)(__props.projectnr.status)), 1)
                ]),
                _: 1
              }, 8, ["content"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => []),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectStep.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", null, [
              (__props.projectnr.type1=='2')
                ? (_openBlock(), _createBlock(_component_el_descriptions_item, { key: 0 }, {
                    label: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AlarmClock)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(_toDisplayString(item.stepname1), 1)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: item.planenddate,
                        "onUpdate:modelValue": ($event: any) => ((item.planenddate) = $event),
                        onChange: ($event: any) => (changeplanendtime('planenddate',item.stepname1,item.stepindex)),
                        type: "date",
                        placeholder: "请选择时间",
                        "value-format": "YYYY-MM-DD",
                        style: {"width":"130px"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (__props.projectnr.type1=='2')
                ? (_openBlock(), _createBlock(_component_el_descriptions_item, { key: 1 }, {
                    label: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AlarmClock)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(_toDisplayString(item.stepname2) + "/负责人 ", 1)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: item.enddate,
                        "onUpdate:modelValue": ($event: any) => ((item.enddate) = $event),
                        onChange: ($event: any) => (changeplanendtime('enddate',item.stepname1,item.stepindex)),
                        type: "date",
                        placeholder: "请选择时间",
                        "value-format": "YYYY-MM-DD",
                        style: {"float":"left","width":"130px"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_el_select, {
                          onChange: ($event: any) => (changezxr(item.stepindex)),
                          size: "small",
                          filterable: "",
                          modelValue: item.operator,
                          "onUpdate:modelValue": ($event: any) => ((item.operator) = $event),
                          placeholder: "请选择",
                          style: {"width":"70px"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: `${item.id},${item.name}`,
                                key: index
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(getStatus2)(item.status)), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]))
          }), 256)),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Document)
                  ]),
                  _: 1
                }),
                _hoisted_24
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                content: __props.projectnr.remark,
                placement: "top",
                disabled: !__props.projectnr.remark
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.projectnr.remark), 1)
                ]),
                _: 1
              }, 8, ["content", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_25,
      (__props.projectnr.type1=='5' && __props.projectnr.weekpath=='')
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _hoisted_27,
            _hoisted_28,
            _hoisted_29,
            _createVNode(_component_el_upload, {
              action: `${api.value}/frame/uploadfile1`,
              "file-list": fileList2.value,
              "on-success": handleSuccess
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_30
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["action", "file-list"]),
            _hoisted_31
          ]))
        : _createCommentVNode("", true),
      (__props.projectnr.type1=='5' && __props.projectnr.weekpath!='')
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _hoisted_33,
            _createVNode(_component_el_table, {
              data: projectWeek.value,
              stripe: "",
              "header-cell-style": {color:'#000',backgroundColor:'#fff'}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  width: "50",
                  label: "",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "ordernumber",
                  label: "订单号",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "squarenumber",
                  label: "平方数",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "startdate1",
                  label: "板投产时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "plenddate1",
                  label: "板完成时间",
                  width: "135"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.plenddate1=='')
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 0,
                          modelValue: scope.row.plenddate11,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.plenddate11) = $event),
                          type: "date",
                          onChange: ($event: any) => (changedatetime(scope.row,scope.row.plenddate11,1)),
                          placeholder: "完成时间",
                          style: {"width":"120px"},
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                      : _createCommentVNode("", true),
                    (scope.row.plenddate1!='')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(scope.row.plenddate1), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "acenddate1",
                  label: "板验收时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "startdate2",
                  label: "料投产时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "plenddate2",
                  label: "料完成时间",
                  width: "135"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.plenddate2=='')
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 0,
                          modelValue: scope.row.plenddate21,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.plenddate21) = $event),
                          type: "date",
                          onChange: ($event: any) => (changedatetime(scope.row,scope.row.plenddate21,2)),
                          placeholder: "完成时间",
                          style: {"width":"120px"},
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                      : _createCommentVNode("", true),
                    (scope.row.plenddate2!='')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(scope.row.plenddate2), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "acenddate2",
                  label: "料验收时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "startdate3",
                  label: "零件油漆投产时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "plenddate3",
                  label: "零件油漆完成时间",
                  width: "135"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.plenddate3==''&&scope.row.startdate3!='')
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 0,
                          modelValue: scope.row.plenddate31,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.plenddate31) = $event),
                          type: "date",
                          onChange: ($event: any) => (changedatetime(scope.row,scope.row.plenddate31,3)),
                          placeholder: "完成时间",
                          style: {"width":"120px"},
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                      : _createCommentVNode("", true),
                    (scope.row.plenddate3!='')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(scope.row.plenddate3), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "acenddate3",
                  label: "零件油漆验收时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "startdate4",
                  label: "组装-墙投产时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "plenddate4",
                  label: "组装-墙完成时间",
                  width: "135"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.plenddate4==''&&scope.row.startdate4!='')
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 0,
                          modelValue: scope.row.plenddate41,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.plenddate41) = $event),
                          type: "date",
                          onChange: ($event: any) => (changedatetime(scope.row,scope.row.plenddate41,4)),
                          placeholder: "完成时间",
                          style: {"width":"120px"},
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                      : _createCommentVNode("", true),
                    (scope.row.plenddate4!='')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(scope.row.plenddate4), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "acenddate4",
                  label: "组装-墙验收时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "startdate5",
                  label: "组装-门投产时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "plenddate5",
                  label: "组装-门完成时间",
                  width: "135"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.plenddate5==''&&scope.row.startdate5!='')
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 0,
                          modelValue: scope.row.plenddate51,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.plenddate51) = $event),
                          type: "date",
                          onChange: ($event: any) => (changedatetime(scope.row,scope.row.plenddate51,5)),
                          placeholder: "完成时间",
                          style: {"width":"120px"},
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                      : _createCommentVNode("", true),
                    (scope.row.plenddate5!='')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(scope.row.plenddate5), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "acenddate5",
                  label: "组装-门验收时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "startdate6",
                  label: "组装-柜投产时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "plenddate6",
                  label: "组装-柜完成时间",
                  width: "135"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.plenddate6==''&&scope.row.startdate6!='')
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 0,
                          modelValue: scope.row.plenddate61,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.plenddate61) = $event),
                          type: "date",
                          onChange: ($event: any) => (changedatetime(scope.row,scope.row.plenddate61,6)),
                          placeholder: "完成时间",
                          style: {"width":"120px"},
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                      : _createCommentVNode("", true),
                    (scope.row.plenddate6!='')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(scope.row.plenddate6), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "acenddate6",
                  label: "组装-柜验收时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "startdate7",
                  label: "二楼底漆/修复投产时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "plenddate7",
                  label: "二楼底漆/修复完成时间",
                  width: "135"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.plenddate7==''&&scope.row.startdate7!='')
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 0,
                          modelValue: scope.row.plenddate71,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.plenddate71) = $event),
                          type: "date",
                          onChange: ($event: any) => (changedatetime(scope.row,scope.row.plenddate71,7)),
                          placeholder: "完成时间",
                          style: {"width":"120px"},
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                      : _createCommentVNode("", true),
                    (scope.row.plenddate7!='')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(scope.row.plenddate7), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "acenddate7",
                  label: "二楼底漆/修复验收时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "startdate8",
                  label: "五楼底漆投产时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "plenddate8",
                  label: "五楼底漆完成时间",
                  width: "135"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.plenddate8==''&&scope.row.startdate8!='')
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 0,
                          modelValue: scope.row.plenddate81,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.plenddate81) = $event),
                          type: "date",
                          onChange: ($event: any) => (changedatetime(scope.row,scope.row.plenddate81,8)),
                          placeholder: "完成时间",
                          style: {"width":"120px"},
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                      : _createCommentVNode("", true),
                    (scope.row.plenddate8!='')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(scope.row.plenddate8), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "acenddate8",
                  label: "五楼底漆验收时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "startdate9",
                  label: "四楼面漆投产时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "plenddate9",
                  label: "四楼面漆完成时间",
                  width: "135"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.plenddate9==''&&scope.row.startdate9!='')
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 0,
                          modelValue: scope.row.plenddate91,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.plenddate91) = $event),
                          type: "date",
                          onChange: ($event: any) => (changedatetime(scope.row,scope.row.plenddate91,9)),
                          placeholder: "完成时间",
                          style: {"width":"120px"},
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                      : _createCommentVNode("", true),
                    (scope.row.plenddate9!='')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(scope.row.plenddate9), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "acenddate9",
                  label: "四楼面漆验收时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "startdate10",
                  label: "安包投产时间",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "plenddate10",
                  label: "安包完成时间",
                  width: "135"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.plenddate10==''&&scope.row.startdate10!='')
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 0,
                          modelValue: scope.row.plenddate101,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.plenddate101) = $event),
                          type: "date",
                          onChange: ($event: any) => (changedatetime(scope.row,scope.row.plenddate101,10)),
                          placeholder: "完成时间",
                          style: {"width":"120px"},
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                      : _createCommentVNode("", true),
                    (scope.row.plenddate10!='')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(scope.row.plenddate10), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "acenddate10",
                  label: "安包验收时间",
                  width: "100"
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_44,
      _hoisted_45,
      _hoisted_46,
      _createVNode(_component_el_input, {
        autosize: {minRows: 6},
        type: "textarea",
        modelValue: logForm.value.updateremark,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((logForm.value.updateremark) = $event)),
        placeholder: "请输入项目日志"
      }, null, 8, ["modelValue"]),
      _hoisted_47,
      _createElementVNode("div", _hoisted_48, [
        _createVNode(_component_el_upload, {
          action: `${api.value}/frame/uploadfile1`,
          "file-list": fileList.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_49
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["action", "file-list"]),
        _createElementVNode("span", _hoisted_50, _toDisplayString(pasteUploading.value ? '上传中…' : 'Ctrl+V 粘贴上传附件'), 1)
      ]),
      _hoisted_51,
      _createElementVNode("div", _hoisted_52, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (submit())),
          round: ""
        }, {
          default: _withCtx(() => [
            _hoisted_53
          ]),
          _: 1
        })
      ]),
      _hoisted_54,
      _hoisted_55,
      _hoisted_56,
      _createVNode(_component_el_input, {
        autosize: {minRows: 6},
        type: "textarea",
        modelValue: __props.projectnr.fp,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.projectnr.fp) = $event)),
        placeholder: "请输入复盘总结"
      }, null, 8, ["modelValue"]),
      _hoisted_57,
      _hoisted_58,
      _createElementVNode("div", _hoisted_59, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (submitfp())),
          round: ""
        }, {
          default: _withCtx(() => [
            _hoisted_60
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_61, [
      _hoisted_62,
      _hoisted_63,
      _createVNode(_component_el_timeline, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logList.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_timeline_item, {
              center: "",
              timestamp: `${item.updatetime} ${item.updatename}`,
              placement: "top",
              key: index,
              id: 'projectlog-'+item.id,
              class: _normalizeClass({'is-focus-log': String(__props.focusLogId)!=='' && String(item.id)===String(__props.focusLogId) })
            }, {
              default: _withCtx(() => [
                (item.filelist=='')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(item.updateremark), 1))
                  : (_openBlock(), _createBlock(_component_el_card, { key: 1 }, {
                      default: _withCtx(() => [
                        _createElementVNode("h4", null, _toDisplayString(item.updateremark), 1),
                        _createElementVNode("p", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.filelist.split(','), (v, i) => {
                            return (_openBlock(), _createElementBlock("a", {
                              href: `${api.value}${v}`,
                              download: `${api.value}${v}`,
                              target: "_blank",
                              key: i,
                              style: {"margin-right":"10px"}
                            }, [
                              _createVNode(_component_el_icon, {
                                size: 36,
                                color: "#409EFF"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Document)
                                ]),
                                _: 1
                              })
                            ], 8, _hoisted_65))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024))
              ]),
              _: 2
            }, 1032, ["timestamp", "id", "class"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})